<template>
  <div>
    <NavigationTo :path="path">
      <div slot="content" class="btn _pointer">
        {{ btnTxt }}
      </div>
    </NavigationTo>
  </div>
</template>

<script>

import {ENV_BASE_URL} from "@/constant/PATH";

export default {
  name: "home-btn",
  props:{
    path: {
      type: String,
      default: ENV_BASE_URL
    },
    btnTxt:{
      type: String,
      default: '返回潮国创意首页'
    }
  },
  data() {
    return {
      ENV_BASE_URL
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  width: 164px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 24px;
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
  position: absolute;
  top: 76px;
  left: 56px;
  z-index: 88;
  cursor: pointer;
}
</style>
